import React, { Component } from 'react';
import axios from '../../axios'
import { connect } from 'react-redux'
import qs from 'qs';
import Alert from 'react-s-alert'

class Profil extends Component {
    constructor(){
        super()

        this.state = {
            user_nama       : "",
            user_username   : "",
            user_password   : "",

            user_id         : "",
            user_level      : "",
            user_foto       : "",
            user_status     : "",

            isButtonLoading : false,
            isLoading       : true,
        }

        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleChange = this.handleChange.bind(this)
    }

    handleSubmit() {
        this.setState({isButtonLoading: true})

        axios({
            method: 'post',
            url: '/user/edit?user_id=' + this.props.user_id,
            data: qs.stringify(this.state)
        })
        .then(response => {


            const result = response.data;

            if (!result.success) {

                if (Array.isArray(result.message)) {

                    result.message.map(item => {
                        Alert.error(item)

                        return true
                    })
                }
                else {

                    Alert.error(result.message)
                }

                this.setState({ isButtonLoading: false })
            }
            else {

                Alert.success(result.message)
                this.props.history.replace("/");
            }
        })
            .catch(error => {

                console.log(error)
                this.setState({ isButtonLoading: false })
                Alert.error("Gagal terhubung ke server!")
            })

    }

    handleChange(event) {

        const target = event.target;
        const value  = target.type === 'checkbox' ? target.checked : target.value;
        const name   = target.name;

        this.setState({
            [name]: value
        })
    }

    componentDidMount() {

        axios({
            method: 'get',
            url: '/user/' + this.props.user_id
        })
        .then(response => {

            const result = response.data;

            this.setState({
                user_id         : result.data.user_id,
                user_nama       : result.data.user_nama,
                user_username   : result.data.user_username,
                user_level      : result.data.user_level,
                user_status     : result.data.user_status,
                isButtonLoading : false,
                isLoading       : false,
            })
        })
        .catch(error => {
            console.log(error)
            this.setState({isLoading: false})
            Alert.error("Gagal terhubung ke server!")
        })
    }

    render() {
        return (
            <div className="animated fadeIn">
                    <div className="card">
                        <div className="card-header">
                            Data Akun Anda
                        </div>
                        <div className="card-block">
                            {
                                this.state.isLoading ? 'Memuat Data...' : (
                                    <div className="form-horizontal animated fadeIn">
                                        <div className="form-group row">
                                            <label className="col-md-2 form-control-label">Nama Lengkap</label>
                                            <div className="col-md-10">
                                                <input
                                                    name="user_nama"
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Nama Lengkap"
                                                    onChange={this.handleChange}
                                                    value={this.state.user_nama} />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-md-2 form-control-label">Username</label>
                                            <div className="col-md-10">
                                                <input
                                                    name="user_username"
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Username (untuk login)"
                                                    onChange={this.handleChange}
                                                    readOnly={true}
                                                    value={this.state.user_username} />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-md-2 form-control-label">Password</label>
                                            <div className="col-md-10">
                                                <input
                                                    name="user_password"
                                                    type="password"
                                                    className="form-control"
                                                    placeholder="Ganti Password anda (Biarkan kosong jika tidak ingin mengganti)"
                                                    onChange={this.handleChange}
                                                    value={this.state.user_password}
                                                    style={{marginBottom: "1rem"}} />
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                        <div className="card-footer">
                            <button
                                type="button"
                                className="btn btn-md btn-primary"
                                disabled={this.state.isButtonLoading && "disabled"}
                                onClick={this.handleSubmit}
                            >
                                {this.state.isButtonLoading ? "Loading" : "Update Profil"}
                            </button>
                        </div>
                    </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    user_id: state.authReducer.user_id
})

export default connect(mapStateToProps)(Profil);



// WEBPACK FOOTER //
// ./src/views/Profil/index.js